export class ServerConfig {
    public webPushPublicKey: string = '';

    constructor() {

    }
}

export const serverConfig = new ServerConfig();